// extracted by mini-css-extract-plugin
export default {"deductions-report-header":"DeductionReport_deductions-report-header__dyLaG"};